module.exports = __webpack_public_path__ + "static/award2-949787574f9e5c3c8c985a527c99c52c.png";